import { useTranslation } from 'react-i18next';
import { type FC, type ReactElement } from 'react';

import PatientServiceRow from './patient-service-row';
import s from '../styles.module.scss';

interface ServicesProps {
  providerServiceType?: string;
  serviceDeliveryModel?: string;
  clinicName?: ReactElement | string;
  physician?: ReactElement | string;
  referralTypes?: string;
  careAgentName?: string;
}

const Services: FC<ServicesProps> = ({
  careAgentName,
  clinicName,
  physician,
  providerServiceType,
  referralTypes,
  serviceDeliveryModel,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.services}>
      <PatientServiceRow
        label={t('labels.providerServiceType')}
        value={providerServiceType}
      />
      <PatientServiceRow
        label={t('labels.serviceDeliveryModel')}
        value={serviceDeliveryModel}
      />
      <div className={s['services-item']}>
        <PatientServiceRow
          label={t('labels.bannerClinic')}
          value={clinicName}
        />
        <div className={s['services-list-divider']} />
        <PatientServiceRow
          label={t('labels.bannerProvider')}
          value={physician}
        />
      </div>
      <PatientServiceRow
        label={t('labels.bannerReferralType')}
        value={referralTypes}
      />
      <PatientServiceRow
        label={t('labels.careManager')}
        value={careAgentName}
      />
    </div>
  );
};
export default Services;
